// src/pages/ContactPage.js
import React, { useState } from 'react';
import PublicNavbar from '../components/PublicNavbar';
import Footer from '../components/Footer'; // Import the new Footer component
// *** Import functions and httpsCallable ***
import { functions } from '../firebase'; 
import { httpsCallable } from 'firebase/functions';
import './ContactPage.css';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [status, setStatus] = useState(''); 

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // *** REFACTORED SUBMIT FUNCTION to use httpsCallable ***
  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Sending...');

    // Get a reference to the 'sendContactEmail' Callable Function.
    const sendContactEmail = httpsCallable(functions, 'sendContactEmail');

    try {
      // Call the function and pass the form data object.
      const result = await sendContactEmail(formData);
      
      if (result.data.success) {
        // On success, display a success message to the user.
        setStatus('Success');
        // Optionally reset the form
        // setFormData({ name: '', email: '', message: '' });
      } else {
        // This else block might not be needed if the function throws errors on failure
        throw new Error('The function reported an issue.');
      }
    } catch (error) {
      // Handle network errors or errors thrown from the function.
      console.error('Error calling the cloud function:', error);
      setStatus(`Error: ${error.message}`);
    }
  };

  return (
    <div className="contact-page">
      <PublicNavbar />
      <div className="contact-header">
      </div>

      <div className="contact-body-container">
        <div className="contact-content-wrapper">
          <div className="contact-info">
            <h3>Contact Information</h3>
            <p>Have a question or want to make a donation?</p> 
            <p>We're here to help.</p>
            <div className="info-item">
              <strong>Locations:</strong>
              <p>Serving Communities in Utah and Arizona. We will be adding new areas soon!</p>
            </div>
          </div>

          <div className="contact-form-container">
            {status === 'Success' ? (
              <div className="thank-you-message">
                <h3>Thank You!</h3>
                <p>Your message has been sent. We'll get back to you shortly.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="contact-form">
                <h3>Send Us a Message</h3>
                <div className="form-group">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="6"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>
                <button type="submit" className="submit-button" disabled={status === 'Sending...'}>
                  {status === 'Sending...' ? 'Sending...' : 'Send Message'}
                </button>
                {status.startsWith('Error:') && <p className="error-message">{status}</p>}
              </form>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ContactPage;